import styled from '@emotion/styled'
import { breakpoint, calcRem } from '@news-mono/component-library'

export const PageWrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    margin: '0 auto',
})

interface PageContentProps {
    hasTopGutter?: boolean
    hasBottomGutter?: boolean
}

export const PageContent = styled.div<PageContentProps>(
    ({ hasTopGutter, hasBottomGutter }) => ({
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',

        paddingTop: hasTopGutter ? calcRem(40) : 0,
        paddingBottom: hasBottomGutter ? calcRem(40) : 0,
        gap: calcRem(32),

        [breakpoint('sm')]: {
            gap: calcRem(64),
            paddingTop: hasTopGutter ? calcRem(48) : 0,
            paddingBottom: hasBottomGutter ? calcRem(48) : 0,
        },

        [breakpoint('lg')]: {
            gap: calcRem(80),
            paddingTop: hasTopGutter ? calcRem(80) : 0,
            paddingBottom: hasBottomGutter ? calcRem(80) : 0,
        },

        transition: 'padding 0.25s, gap 0.25s',
    }),
)
